import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

export const DarkModeContext = createContext();

export function DarkModeProvider({ children }) {
  const [darkMode, setDarkModeState] = useState(false);
  const { user } = useAuth();

  // Fetch dark mode din backend la mount și la schimbarea user-ului
  useEffect(() => {
    const fetchDarkMode = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : ''}/user`, {
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          if (typeof data.dark_mode === 'boolean') {
            setDarkModeState(data.dark_mode);
          } else {
            setDarkModeState(false);
          }
        } else {
          setDarkModeState(false);
        }
      } catch (e) {
        setDarkModeState(false);
      }
    };
    fetchDarkMode();
  }, [user]);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }, [darkMode]);

  // Funcție care setează local și salvează și pe backend
  const setDarkMode = (valueOrUpdater) => {
    setDarkModeState(prev => {
      const newValue = typeof valueOrUpdater === 'function' ? valueOrUpdater(prev) : valueOrUpdater;

      fetch('/user/theme', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ dark_mode: newValue })
      });

      return newValue;
    });
  };

  return (
    <DarkModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export function useDarkMode() {
  return useContext(DarkModeContext);
}
